<template>
  <div>
    <!--测试方案-->
    <div class="demand-detail"
         :class="{'share-detail': !enquiryDetail.showBtn}">
      <div class="company-content">
        <span class="companyName">{{enquiryDetail.baisc.companyName}}</span>
        <!--<span class="categoryPath">{{enquiryDetail.baisc.productName}}</span>-->
        <span class="categoryPath">{{enquiryDetail.baisc.categoryPath && enquiryDetail.baisc.categoryPath.split('/')[enquiryDetail.baisc.categoryPath.split('/').length - 1]}}</span>
        <span>测试方案</span>
        <img v-if="!enquiryDetail.showBtn"
             src="../../assets/images/quote-logo.png">
      </div>
      <div class="order-basic">
        <div class="basic-item">
          <span class="basic-item-icon"></span>
          <span class="basic-label">询价单号：</span>
          <span class="basic-value">{{enquiryDetail.baisc.orderNo}}</span>
        </div>
        <div class="basic-item">
          <span class="basic-item-icon"></span>
          <span class="basic-label">报价时间：</span>
          <span class="basic-value">{{enquiryDetail.baisc.offerDate && enquiryDetail.baisc.offerDate.slice(0, 10)}}</span>
        </div>
        <div class="basic-item">
          <span class="basic-item-icon"></span>
          <span class="basic-label">有效期至：</span>
          <span class="basic-value">{{enquiryDetail.baisc.orderExpDate && enquiryDetail.baisc.orderExpDate.slice(0, 10)}}</span>
        </div>
        <div class="basic-item">
          <span class="basic-item-icon"></span>
          <span class="basic-label">方案制作：</span>
          <span class="basic-value">{{enquiryDetail.csInfo.personName || enquiryDetail.csInfo.personCode}}</span>
        </div>
      </div>
      <div class="order-msg">
        <div class="order-user-msg">尊敬的 <span style="color: #ca4300;">{{enquiryDetail.baisc.userName}}</span>
          {{enquiryDetail.baisc.userSex === 2 ? '女士' : enquiryDetail.baisc.userSex === 1 ? '先生' : ''}}，您好！</div>
        <div class="order-msg-content"
             v-html="textareaWrap(enquiryDetail.baisc.recommendReason)"></div>
        <div class="order-file-list"
             v-if="enquiryDetail.baisc.recommendReasonImage">
          <el-tooltip placement="bottom"
                      :disabled="!/\.(jpg|jpeg|png|gif|bmp|GIF|BMP|JPG|PNG)/.test(item.url)"
                      effect="light"
                      :visible-arrow="false"
                      popper-class="prev-img"
                      v-for="(item, index) in enquiryDetail.baisc.recommendReasonImage"
                      :key="index">
            <div class="order-file-item"
                 @click="openFile(item)">
              <template>
                <img v-if="/\.(jpg|jpeg|png|gif|bmp|GIF|BMP|JPG|PNG)/.test(item.url)"
                     :src="item.url"
                     alt="">
                <div class="file-img"
                     v-else>
                  <img :src="fileIcon"
                       alt="">
                </div>
              </template>
              <div class="file-name">{{item.name}}</div>
            </div>
            <div slot="content"
                 style="cursor: pointer"
                 @click="openFile(item)">
              <img :src="item.url"
                   width="500px">
            </div>
          </el-tooltip>
        </div>
      </div>
      <div class="specialNote"
           v-if="enquiryDetail.baisc.specialNote && enquiryDetail.baisc.specialNote[0]">
        {{enquiryDetail.baisc.specialNote[0].attrName}}
      </div>
      <div v-if="enquiryDetail.showBtn"
           class="cs-content">
        <div class="cs-top">工程师企业微信</div>
        <div class="cs-info">
          <div class="cs-name">{{enquiryDetail.csInfo.personName}}</div>
          <div class="cs-name-en">{{enquiryDetail.csInfo.personNameEn}}</div>
        </div>
        <div class="cs-job">
          <span>{{enquiryDetail.csInfo.stationName}}</span>
        </div>
        <div class="cs-job">
          <span>{{enquiryDetail.csInfo.selfDesc}}</span>
        </div>
        <div class="cs-btn-content">
          <img :src="enquiryDetail.csInfo.qrCode || enquiryDetail.csInfo.customQrCode || qrCode" />
        </div>
      </div>
      <template v-if='selectedTestItem.length || toSelectTestItem.length'>
        <div class="test-item-label is-selected"
             v-if="operateRow">
          <i class="icon"></i>
          已选项目 ({{selectedTestItem.length}})
          <div class="price">
            <span class="price-label">项目原价</span>
<!--            <span class="price-detail">{{testTotalPrice}}</span>-->
            <span class="price-detail">{{OriginalPrice}}</span>
          </div>
        </div>
        <test-item :list="selectedTestItem"
                   :operateRow="operateRow"
                   :toSelectTestItem.sync="toSelectTestItem"
                   :selectedTestItem.sync="selectedTestItem"></test-item>
        <!--<div class="test-item-label to-select"
             v-if="operateRow">
          <span @click="selectedTestItemShow = !selectedTestItemShow"
                style="cursor: pointer">
            <i class="icon"
               :class="{'is-up': !selectedTestItemShow}"></i>
            可选项目
          </span>
        </div>
        <test-item v-if="operateRow && selectedTestItemShow"
                   :list="toSelectTestItem"
                   :operateRow="operateRow"
                   :toSelectTestItem.sync="toSelectTestItem"
                   :selectedTestItem.sync="selectedTestItem"></test-item>-->
        <br />
        <div class="bottom-content">
          <div class="more-content"
               id="otherPrice">
            <div class="more-item"
                 v-if="(enquiryDetail.baisc.reportLuaList && enquiryDetail.baisc.reportLuaList.length) || (enquiryDetail.baisc.state === 4 && enquiryDetail.baisc.reportLuaValue)">
              <div class="more-label">
                <span class="label-span">报告语言</span>
              </div>
              <template>
                <div class="more-value"
                     v-if="enquiryDetail.baisc.state === 3">
                  <el-radio :disabled='item.isDisable'
                            v-model="reportLuaRadio"
                            :label="item.id"
                            v-for="(item, index) in enquiryDetail.baisc.reportLuaList"
                            :key="index">{{item.attrName}}{{item.attrAmount ? '(+' + item.attrAmount + '元)' : ''}}</el-radio>
                </div>
                <div class="more-value" v-else style="line-height: 24px">{{enquiryDetail.baisc.reportLuaValue || enquiryDetail.baisc.reportLua}}</div>
              </template>
              <el-button class="businessLine-btn"
                         v-if='enquiryDetail.baisc.orderDetailDTOList && enquiryDetail.baisc.orderDetailDTOList.length'
                         type="text"
                         @click="goLabPage(enquiryDetail.baisc.businessLine)">了解{{enquiryDetail.baisc.businessLine}}实验室</el-button>
            </div>
            <div class="more-item"
                 v-if="(enquiryDetail.baisc.reportFormList && enquiryDetail.baisc.reportFormList.length)  || (enquiryDetail.baisc.state === 4 && enquiryDetail.baisc.reportFormValue)">
              <div class="more-label">
                <span class="label-span">报告形式</span>
              </div>
              <div class="more-value"
                   v-if="enquiryDetail.baisc.state === 3">
                <el-radio :disabled='item.isDisable'
                          v-model="reportFormRadio"
                          :label="item.id"
                          v-for="(item, index) in enquiryDetail.baisc.reportFormList"
                          :key="index">{{item.attrName}}{{item.attrAmount ? '(+' + item.attrAmount + '元)' : ''}}</el-radio>
              </div>
              <div class="more-value" v-if="enquiryDetail.baisc.state === 4"  style="line-height: 24px">{{enquiryDetail.baisc.reportFormValue || enquiryDetail.baisc.reportForm}}</div>
            </div>
            <div class="more-item" v-if="enquiryDetail.baisc.reportMemo" style="padding-left: 115px;font-size: 12px;color: #878787;">报告说明：{{enquiryDetail.baisc.reportMemo}}</div>
            <div class="more-item"
                 v-if="(enquiryDetail.baisc.labList && enquiryDetail.baisc.labList.length) || (enquiryDetail.baisc.state === 4 && enquiryDetail.baisc.labNameValue)">
              <div class="more-label">
                <span class="label-span">执行实验室</span>
              </div>
              <div class="more-value"
                   v-if="enquiryDetail.baisc.state === 3">
                <el-radio v-model="labRadio"
                          :label="item.id"
                          v-for="(item, index) in enquiryDetail.baisc.labList"
                          :key="index">{{item.attrName}}</el-radio>
              </div>
              <div class="more-value" v-if="enquiryDetail.baisc.state === 4"  style="line-height: 24px">{{enquiryDetail.baisc.labNameValue || enquiryDetail.baisc.labName}}</div>
            </div>
            <div class="more-item"
                 v-if="(enquiryDetail.baisc.testCycleList && enquiryDetail.baisc.testCycleList.length) || (enquiryDetail.baisc.state === 4 && enquiryDetail.baisc.testCycle)">
              <div class="more-label">
                <span class="label-span">测试周期</span>
              </div>
              <div class="more-value"
                   v-if="enquiryDetail.baisc.state === 3">
                <!--<el-radio v-model="dayRadio" label="" style="margin-right: 0;">{{enquiryDetail.baisc.testCycle}}个工作日</el-radio>-->
                <el-radio v-model="testCycleRadio"
                          :label="item.id"
                          v-for="(item, index) in enquiryDetail.baisc.testCycleList"
                          :key="index">
                  <span
                      v-if="testTotalPrice === '待定'">{{item.attrName}}{{item.attrExtend != 0 ? item.attrExtend + '个工作日' : ''}}{{getTestAmount(item.attrAmount).toFixed(2) !== '0.00' ? '(+' + getTestAmount(item.attrAmount) + '%)' : ''}}</span>
                  <span
                      v-else>{{item.attrName}}{{item.attrExtend != 0 ? item.attrExtend + '个工作日' : ''}}{{getTestAmount(item.attrAmount).toFixed(2) !== '0.00' ? '(+' + getTestAmount(item.attrAmount).toFixed(2) + '元)' : ''}}</span>
                </el-radio>
                <!--{{enquiryDetail.baisc.testCycle}}个工作日
                <span class="day-tips">
                  （ 如需加急，<span style="color: #ca4300;text-decoration: underline;cursor: pointer" @click="kf5Click">联系工程师</span> ）
                </span>-->
              </div>
              <div class="more-value" v-if="enquiryDetail.baisc.state === 4"  style="line-height: 24px">{{enquiryDetail.baisc.testCycle}}个工作日</div>
            </div>
            <div class="more-item"
                 style="margin-bottom: 20px;height: auto;"
                 v-if="enquiryDetail.baisc.testCycleMemo">
              <div class="more-label"></div>
              <div class="more-value"
                   style="color: #B2B2B2;word-break:break-all;">{{enquiryDetail.baisc.testCycleMemo}}</div>
            </div>
            <div class="more-item other-item">
              <div class="more-label">判定要求</div>
              <div class="more-value"
                   style="font-size: 14px;"
                   v-if='enquiryDetail.baisc.isDetermine > 0'>
                需要判定{{enquiryDetail.baisc.determine ?  `,${enquiryDetail.baisc.determine}` : ''}}
              </div>
              <div v-else
                   class="more-value"
                   style="font-size: 14px;">
                不需要判定
              </div>
            </div>
            <div class="more-item other-item">
              <div class="more-label">样品要求</div>
              <div class="more-value"
                   v-html="textareaWrap(enquiryDetail.baisc.sampleRequirements)"></div>
            </div>
          </div>
          <div class="price-content">
            <div class="price-detail">
              <div class="price-item">
                <div class="price-item-label">项目原价：</div>
<!--                <div class="price-item-content">{{testTotalPrice}}</div>-->
                <div class="price-item-content">{{OriginalPrice}}</div>
              </div>
              <div class="price-item"
                   v-if="flagShow">
                <div class="price-item-label">优惠信息：</div>
                                <div class="price-item-content"
                                     style="position: relative; left: -4px;">-{{PreferentialInformation}}(-{{PreferentialRatio}}%)</div>
<!--                <div class="price-item-content"-->
<!--                     style="position: relative; left: -4px;">{{'-' + discountPrice}}{{testTotalPrice === '待定' ? '' : `(-${enquiryDetail.baisc.discountAmountNum[0].attrAmount}%)`}}</div>-->
              </div>
              <div class="price-item"
                   v-if="enquiryDetail.baisc.state === 3 && otherPriceById[testCycleRadio] && (getTestAmount(otherPriceById[testCycleRadio]) || 0).toFixed(2) !== '0.00'">
                <div class="price-item-label">附加加急费：</div>
                <div class="price-item-content"
                     v-if="testTotalPrice !== '待定'">{{(getTestAmount(otherPriceById[testCycleRadio]) || 0).toFixed(2)}}</div>
                <div class="price-item-content"
                     v-if="testTotalPrice === '待定'">{{getTestAmount(otherPriceById[testCycleRadio])}}%</div>
              </div>
              <div class="price-item"
                   v-if="enquiryDetail.baisc.state === 4 && enquiryDetail.baisc.urgentAmount !== '0.00'">
                <div class="price-item-label">附加加急费：</div>
                <div class="price-item-content">{{enquiryDetail.baisc.urgentAmount}}</div>
              </div>
              <!--<div class="price-item" v-if="enquiryDetail.baisc.discountAmountNum && enquiryDetail.baisc.discountAmountNum[0].attrAmount !== 0">
                <div class="price-item-label">折后价格：</div>
                <div class="price-item-content">{{afterFoldPrice}}</div>
              </div>-->
              <div class="price-item"
                   v-if="otherTotalPrice !== '0.00'">
                <div class="price-item-label">其他费用：</div>
                <div class="price-item-content">{{otherTotalPrice}}</div>
              </div>
              <div class="price-item">
                <div class="price-item-label">税<span style="visibility: hidden;">占位</span>率：</div>
                <div class="price-item-content">6%</div>
              </div>
              <div class="price-item">
                <div class="price-item-label total">税后总价：</div>
                <div class="price-item-content total">
                  <span>
                    {{totalPrice}}
                  </span>
                </div>
              </div>
              <div class="price-item"
                   v-if="enquiryDetail.baisc.state !== 4">
                <div class="price-item-label tips">立刻锁定价格！</div>
              </div>
              <div v-if="(enquiryDetail.baisc.state==3 || enquiryDetail.baisc.state==4) && enquiryDetail.showBtn"
                   style="text-align: center;margin-bottom: 20px;">
                <el-button type="text"
                           class="submit-demand"
                           @click="AnotherList"
                           :loading="enquiryDetail.AnotherListloading">复制询价需求</el-button>
              </div>
              <div class="btns"
                   v-if="enquiryDetail.baisc.state === 4 && enquiryDetail.showBtn">
                <el-button type="primary"
                           class="confirm-order-btn"
                           @click="goToOrder">
                  去订单
                  <img src="../../assets/images/aircraft.png"
                       alt="">
                </el-button>
                <el-button type="primary"
                           class="share-btn"
                           @click='handleSearchDialog'>
                  <img src="../../assets/images/quote/share.png"
                       alt="">
                  <span>分享</span>
                </el-button>
              </div>
            </div>
            <el-button v-if="enquiryDetail.baisc.state==3&&isCsConfirm" type="primary" @click="csConfirmOrder" class="confirm-order" size="small">代客户确认方案</el-button>
          </div>
        </div>

      </template>
    </div>
  </div>
</template>

<script>
import {textareaWrap, windowOpen} from './../../utils'
import TestItem from './TestItem'
import * as math from 'mathjs'
import fileIcon from '../../assets/images/fileIcon.png'
// import package from './../../../package.json'

export default {
  name: 'TicEnquiryDetail',
  components: { TestItem },
  props: {
    enquiryDetail: {
      default: () => {},
      type: Object,
    },
    isCsConfirm: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      textareaWrap,
      selectedTestItem: [],
      toSelectTestItem: [],
      selectedTestItemShow: true,
      data: {},
      otherPriceById: {},
      reportLuaRadio: '',
      reportFormRadio: '',
      labRadio: '',
      testCycleRadio: '',
      fileIcon,
      init: false,
      qrCode: require('./../../assets/images/qrCode.jpg'),
      flag:false
    }
  },
  computed: {
    flagShow(){
      let attrAmount=this.enquiryDetail.baisc.discountAmountNum && this.enquiryDetail.baisc.discountAmountNum[0] && this.enquiryDetail.baisc.discountAmountNum[0].attrAmount
      return !(attrAmount === 0 && !this.flag);
      // enquiryDetail.baisc.discountAmountNum && enquiryDetail.baisc.discountAmountNum[0] && enquiryDetail.baisc.discountAmountNum[0].attrAmount === 0&& flag
    },
    operateRow() {
      if (
          this.enquiryDetail &&
          this.enquiryDetail.baisc &&
          this.enquiryDetail.baisc.state === 4
      ) {
        return false
      }
      return this.selectedTestItem
          .concat(this.toSelectTestItem)
          .some((v) => v.isOptional === 1)
    },
    //项目原价
    OriginalPrice(){
      if (
          this.data.state === 3 &&
          this.selectedTestItem.some((v) => v.totalPrice === '')
      ) {
        return '待定'
      }
      let price = 0
      this.selectedTestItem.forEach((v, i) => {
        if(v.priceNum !==100){
          this.flag=true
        }
        const currPrice = v.originalTotalPrice || 0
        price = math.chain(price).add(currPrice).done()
      })
      return price.toFixed(2)
    },
    //优惠信息
    PreferentialInformation(){
      if (
          this.data.state === 3 &&
          this.selectedTestItem.some((v) => v.totalPrice === '')
      ) {
        return '待定'
      }
      //优惠信息=项目原价-最终优惠价格
      //优惠百分比=（项目原价-最终优惠价格）/项目原价
      //testTotalPrice 项目原价
      //FinalPreferentialPrice 最终优惠价格
      let FinalPreferentialPrice=0
      let discountPrice=0 //折扣价
      this.selectedTestItem.forEach((v, i) => {
        // const currPrice = v.price || 0
        // discountPrice = math.chain(discountPrice).add(currPrice).done()
        discountPrice +=v.price * v.buyNums
      })
      FinalPreferentialPrice=discountPrice*(100-this.enquiryDetail.baisc.discountAmountNum[0].attrAmount)/100
      return (Number(this.OriginalPrice) - Number(FinalPreferentialPrice)).toFixed(2)
      // return  testTotalPrice-testTotalPrice*(100-Number(enquiryDetail.baisc.discountAmountNum[0].attrAmount))
    },
    //优惠信息比
    PreferentialRatio(){
      return  ((Number(this.PreferentialInformation)/Number(this.OriginalPrice))*100).toFixed(2)
    },
    testTotalPrice() {
      if (
          this.data.state === 3 &&
          this.selectedTestItem.some((v) => v.totalPrice === '')
      ) {
        return '待定'
      }
      let price = 0
      this.selectedTestItem.forEach((v, i) => {
        const currPrice = v.totalPrice || 0
        price = math.chain(price).add(currPrice).done()
      })
      return price.toFixed(2)
    },
    discountPrice() {
      if (!this.data.discountAmountNum || !this.data.discountAmountNum.length) {
        return 0
      }
      if (this.testTotalPrice === '待定') {
        return `${this.data.discountAmountNum[0].attrAmount}%`
      }
      if (!this.data.discountAmountNum) {
        return 0
      }
      return math
          .chain(this.testTotalPrice)
          .multiply(this.data.discountAmountNum[0].attrAmount)
          .divide(100)
          .done()
          .toFixed(2)
    },
    otherTotalPrice() {
      if (this.data.state === 4) {
        return this.data.serviceAmount
      }
      const luaPrice = this.otherPriceById[this.reportLuaRadio] || 0
      const formPrice = this.otherPriceById[this.reportFormRadio] || 0
      const labPrice = this.otherPriceById[this.labRadio] || 0
      return math.chain(luaPrice).add(formPrice).add(labPrice).done().toFixed(2)
    },
    totalPrice() {
      if (
          this.data.state === 3 &&
          (this.floatOtherPrice === false || this.testTotalPrice === '待定')
      ) {
        return '待定'
      }
      const afterFoldPrice = this.afterFoldPrice || 0
      const otherTotalPrice = this.otherTotalPrice || 0
      return math
          .chain(afterFoldPrice)
          .add(otherTotalPrice)
          .multiply(1.06)
          .done()
          .toFixed(2)
    },
    floatOtherPrice() {
      // 浮动按钮区域附加费用
      if (!this.reportLuaRadio || !this.reportFormRadio) {
        return false
      }
      if (
          this.otherPriceById[this.testCycleRadio] !== 0 &&
          this.testTotalPrice === '待定'
      ) {
        return '待定'
      }
      const testCycle =
          this.getTestAmount(this.otherPriceById[this.testCycleRadio]) || 0
      const luaPrice = this.otherPriceById[this.reportLuaRadio] || 0
      const formPrice = this.otherPriceById[this.reportFormRadio] || 0
      const labPrice = this.otherPriceById[this.labRadio] || 0
      return math
          .chain(luaPrice)
          .add(formPrice)
          .add(labPrice)
          .add(testCycle)
          .done()
          .toFixed(2)
    },
    afterFoldPrice() {
      if (this.testTotalPrice === '待定') {
        return '待定'
      }
      const orderAmount = this.testTotalPrice || 0
      const discountAmount = this.discountPrice || 0
      const urgentAmount =
          (this.data.state === 3
              ? this.getTestAmount(this.otherPriceById[this.testCycleRadio])
              : this.data.urgentAmount) || 0
      return math
          .chain(orderAmount)
          .subtract(discountAmount)
          .add(urgentAmount)
          .done()
          .toFixed(2)
    },
  },
  watch: {
    enquiryDetail: {
      handler(val) {
        if (val && val.baisc) {
          if (this.init) {
            return
          }
          this.init = true
          this.data = val.baisc
          this.selectedTestItem = []
          this.toSelectTestItem = []
          if (this.enquiryDetail.formatList) {
            let all = this.data.orderDetailDTOList
            all.forEach((value, index, array) => {
              if (value.isDefault === 0) {
                this.toSelectTestItem.push(value)
              } else {
                this.selectedTestItem.push(value)
              }
            })
          } else {
            this.selectedTestItem = val.baisc.orderDetailDTOList || []
            this.toSelectTestItem = val.baisc.orderDetailOptionalList || []
          }
          this.reportLuaRadio = this.getRadioValue(
              this.data.reportLuaList || []
          )
          this.labRadio = this.getRadioValue(this.data.labList || [])
          this.reportFormRadio = this.getRadioValue(
              this.data.reportFormList || []
          )
          this.testCycleRadio = this.getRadioValue(
              this.data.testCycleList || []
          )
        }
      },
      immediate: true,
    },
    selectedTestItem: {
      handler(val) {
        this.changeData({
          key: 'selectedTestItem',
          value: JSON.parse(JSON.stringify(val)),
        })
      },
      immediate: true,
    },
    toSelectTestItem: {
      handler(val) {
        this.changeData({
          key: 'toSelectTestItem',
          value: JSON.parse(JSON.stringify(val)),
        })
      },
      immediate: true,
    },
    totalPrice: {
      handler(val) {
        this.changeData({ key: 'totalPrice', value: val })
      },
      immediate: true,
    },
    PreferentialInformation:{
      handler(val) {
        this.changeData({ key: 'PreferentialInformation', value: val })
      },
      immediate: true,
    },
    OriginalPrice:{
      handler(val) {
        this.changeData({ key: 'OriginalPrice', value: val })
      },
      immediate: true,
    },
    testTotalPrice: {
      handler(val) {
        this.changeData({ key: 'testTotalPrice', value: val })
      },
      immediate: true,
    },
    floatOtherPrice: {
      handler(val) {
        this.changeData({ key: 'floatOtherPrice', value: val })
      },
      immediate: true,
    },
    discountPrice: {
      handler(val) {
        this.changeData({ key: 'discountPrice', value: val })
      },
      immediate: true,
    },
    reportFormRadio: {
      handler(val) {
        this.changeData({ key: 'reportFormRadio', value: val })
      },
      immediate: true,
    },
    labRadio: {
      handler(val) {
        this.changeData({ key: 'labRadio', value: val })
      },
      immediate: true,
    },
    testCycleRadio: {
      handler(val) {
        this.changeData({ key: 'testCycleRadio', value: val })
      },
      immediate: true,
    },
    reportLuaRadio: {
      handler(nVal, oVal) {
        this.changeData({ key: 'reportLuaRadio', value: nVal })
        // if(this.data.reportLuaList && this.data.reportFormList && oVal) {
        const data = this.enquiryDetail.baisc
        if (data.reportLuaList && data.reportFormList) {
          // 报告语言对应的中文
          const lauItem = data.reportLuaList.filter((v) => {
            return v.id === nVal
          })
          const lauName = lauItem.length ? lauItem[0].attrName : ''
          // 报告形式对应的中文
          const formItem = data.reportFormList.filter((v) => {
            return v.id === this.reportFormRadio
          })
          const formName = formItem.length ? formItem[0].attrName : ''
          console.log(lauName, 'lauName')
          if (lauName === '中文报告' || lauName === '英文报告') {
            data.reportFormList.map((v) => {
              return (v.isDisable = true)
            })
            data.reportFormList.map((v) => {
              if (v.attrName === '电子报告' || v.attrName === '电子+纸质报告') {
                v.isDisable = false
              }
            })
            console.log(formName, 'formName')
            // 当前默认选中的报告形式不是《电子报告》或《电子+纸质报告》则取消默认选择
            if (formName !== '电子报告' && formName !== '电子+纸质报告') {
              this.reportFormRadio = 0
            }
          } else {
            data.reportFormList.map((v) => {
              v.isDisable = false
            })
          }
          data.reportFormList = JSON.parse(JSON.stringify(data.reportFormList))
        }
      },
      immediate: true,
    },
  },
  mounted() {
    console.log(this.enquiryDetail)
    console.log('package 52', )
  },
  methods: {
    csConfirmOrder() {
      if (this.selectedTestItem.some(v => v.totalPrice === '') || this.testTotalPrice ==='0.00') {
        this.$message.error('价格为0元或待定时无法确认。')
        return
      }
      if (!this.reportLuaRadio) {
        this.$message.error('请选择报告语言')
        return
      }
      if (!this.reportFormRadio) {
        this.$message.error('请选择报告形式')
        return
      }
      if (!this.labRadio) {
        this.$message.error('请选择执行实验室')
        return
      }
      if (!this.testCycleRadio) {
        this.$message.error('请选择测试周期')
        return
      }
      this.$emit('goConfirmOrder', {
        labId: this.labRadio,
        reportLuaId: this.reportLuaRadio,
        reportFormId: this.reportFormRadio,
        testCycleId: this.testCycleRadio,
      })
    },
    changeData(data) {
      this.$emit('changeData', data)
    },
    openFile(data) {
      windowOpen(data.url)
      // this.$emit('openFile', data)
    },
    getRadioValue(data) {
      let defaultId
      data.forEach((v) => {
        this.otherPriceById[v.id] = v.attrAmount
        if (v.isDefault === 1) {
          defaultId = v.id
        }
      })
      return defaultId
    },
    getTestAmount(num) {
      if (!num) {
        return 0
      }
      if (this.testTotalPrice === '待定') {
        return num
      }
      return math
          .chain(this.testTotalPrice)
          .subtract(this.discountPrice)
          .multiply(num)
          .divide(100)
          .done()
    },
    //再来一单
    AnotherList() {
      this.$emit('AnotherList')
    },
    //去订单
    goToOrder() {
      this.$emit('goToOrder')
    },
    // 获取加密后的orderNo
    handleSearchDialog() {
      this.$emit('handleSearchDialog')
    },
    goLabPage(businessLine) {
      // this.$emit('goLabPage', businessLine)
      if (businessLine.includes('金属')) {
        windowOpen('https://www.sgsonline.com.cn/lab/metal')
      } else if (businessLine.includes('高分子')) {
        windowOpen('https://www.sgsonline.com.cn/lab/polymer')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.demand-detail.share-detail {
  .company-content {
    width: auto;
    img {
      right: 0;
    }
  }
}
.bottom-content {
  display: flex;
  margin-right: -31px;
  margin-left: -31px;
  border-top: 1px solid #d2d2d2;
  /*background: #F8F8F8;*/
  .more-content {
    width: 874px;
    padding-right: 32px;
    background: #fff;
    padding-left: 31px;
  }
  .price-content {
    flex: 1;
    position: relative;
    padding-bottom: 45px;
    .confirm-order {
      position: absolute;
      bottom:8px;
      right: 26px;
    }
  }
}
.demand-detail {
  * {
    box-sizing: border-box;
  }
}
.test-item-label {
  padding: 13px 10px;
  margin-left: -31px;
  margin-right: -31px;
  border-top: 1px solid #d2d2d2;
  font-size: 14px;
  font-weight: bold;
  color: #ca4303;
  position: relative;
  .price {
    position: absolute;
    top: 13px;
    right: 23px;
    font-size: 14px;
    color: #333333;
    font-weight: 400;
    .price-detail {
      font-weight: bold;
      color: #ca4303;
      margin-left: 20px;
    }
  }
  &.is-selected {
    .icon {
      width: 6px;
      height: 6px;
      background: #e9e9e9;
      margin-left: 14px;
      margin-right: 10px;
      display: inline-block;
    }
  }
  &.to-select {
    .icon {
      display: inline-block;
      width: 9px;
      height: 11px;
      margin-left: 10px;
      margin-right: 11px;
      background: url('../../assets/images/quote/toSelect.png');
      &.is-up {
        background: url('../../assets/images/quote/toSelectUp.png');
      }
    }
  }
}
.bottom-content {
  display: flex;
  margin-right: -31px;
  margin-left: -31px;
  border-top: 1px solid #d2d2d2;
  /*background: #F8F8F8;*/
  .more-content {
    width: 874px;
    padding-right: 32px;
    background: #fff;
    padding-left: 31px;
  }
  .price-content {
    flex: 1;
  }
}
.confirm-order-btn {
  width: 220px;
  height: 65px;
  border-radius: 0;
}
.share-btn {
  width: 65px;
  height: 65px;
  border-radius: 0;
  background: #fff4ee;
  border: none;
  color: #ca4300;
  margin: 0;
  font-size: 12px;
}
.float-btn {
  position: relative;
  margin-left: -31px;
  margin-right: -31px;
  bottom: 2px;
  &.is-fixed {
    position: fixed;
    bottom: 0;
    width: 100%;
    right: 0;
    margin: 0;
  }
  .float-btn-content {
    width: 1162px;
    height: 65px;
    background: #fff4ee;
    box-shadow: 0px -5px 16px 0px rgba(0, 0, 0, 0.1);
    margin: auto;
    padding: 15px 0 15px 68px;
    position: relative;
    border-left: 7px solid #ca4300;
  }
  .btns {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
  }
  .submit-demand-btn {
    margin: 0;
  }
  .price-detail {
    display: flex;
    width: 787px;
  }
  .price-item {
    font-size: 14px;
    color: #333333;
    line-height: 35px;
    margin-right: 20px;
    .price {
      color: #ca4300;
    }
  }
}
.main-content {
  background: #f7f5f6;
  padding: 0 0 57px 0;
  position: relative;
}
.quote-state-content {
  background: #fff;
  padding: 27px 32px;
}
.quote-time-no {
  padding: 0 33px;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(135, 135, 135, 1);
  position: relative;
  & > span {
    margin-right: 40px;
  }
  .download-apply-form {
    position: absolute;
    right: 59px;
    padding: 0;
    img {
      vertical-align: middle;
    }
  }
}
.quote-state-detail {
  background: #fafafa;
  height: 102px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 33px;
  .quote-state-label {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: rgba(1, 1, 1, 1);
    line-height: 30px;
    margin-bottom: 13px;
    .reload-btn {
      display: inline-block;
      width: 36px;
      height: 22px;
      border: 1px solid #aaaaaa;
      border-radius: 4px;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      color: #878787;
      line-height: 20px;
      position: relative;
      margin-left: 15px;
      top: -8px;
      cursor: pointer;
      &.order-btn {
        width: 66px;
        margin-left: 5px;
      }
      &:hover {
        border-color: #ca4300;
        background: #ca4300;
        color: #fff;
      }
    }
  }
  .quote-state-tips {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(135, 135, 135, 1);
  }
  .quote-price {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
    line-height: 35px;
    margin-right: 36px;
  }
}
.urge-btn {
  width: 140px;
  height: 35px;
  border: none;
  line-height: 35px;
  padding: 0;
  border-radius: 0;
}
.urge-upload-btn {
  width: 140px;
  height: 35px;
  line-height: 35px;
  padding: 0;
  background: #f5f5f5;
  border: 1px solid #dcdcdc;
  border-radius: 0;
  color: #333333;
  position: absolute;
  bottom: 25px;
  right: 188px;
  img {
    vertical-align: text-top;
    margin-right: 10px;
  }
}
.quote-log-content {
  background: #ffffff;
  height: 74px;
  transition: 0.3s;
  padding: 27px 32px;
  margin-top: 27px;
  overflow: hidden;
  &.isExpand {
    height: 329px;
  }
  .quote-log-title {
    padding: 0 36px 0 25px;
    font-size: 18px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 27px;
    display: flex;
    justify-content: space-between;
    .toggle-open-btn {
      color: #878787;
      font-size: 14px;
      line-height: 18px;
      cursor: pointer;
    }
  }
  .log-content {
    display: flex;
    justify-content: space-between;
  }
  .log-detail {
    width: 575px;
    height: 228px;
    border: 1px solid rgba(216, 216, 216, 1);
    overflow: auto;
    padding: 20px 25px;
    .oper-log {
      display: flex;
    }
    .oper-user {
      width: 104px;
      margin-right: 10px;
    }
    .oper-text {
      flex: 1;
      /*white-space:nowrap;!* 规定文本是否折行 *!*/
      /*overflow: hidden;!* 规定超出内容宽度的元素隐藏 *!*/
      /*text-overflow: ellipsis;*/
      max-width: 225px;
      a {
        color: #2b02fe;
        text-decoration: underline;
        margin-left: 5px;
      }
      .file-memo {
        max-height: 16px;
        overflow: hidden;
        font-size: 12px;
        margin-top: 10px;
        text-overflow: ellipsis;
        position: relative;
        line-height: 16px;
      }
      .one-row {
        display: inline-block;
        white-space: nowrap; /* 规定文本是否折行 */
        overflow: hidden; /* 规定超出内容宽度的元素隐藏 */
        text-overflow: ellipsis;
        position: absolute;
        top: 0;
        left: 0;
      }
      .is-hidden {
        visibility: hidden;
      }
      .toggle-btn {
        background: #fff;
        position: absolute;
        right: 0;
        top: 0;
        &.is-expand {
          position: static;
        }
        i {
          display: inline-block;
          width: 13px;
          height: 13px;
          cursor: pointer;
        }
        .expand-icon {
          background: url('../../assets/images/memo-expand-icon.png');
        }
        .close-icon {
          background: url('../../assets/images/memo-close-icon.png');
        }
      }
    }
    .oper-date {
      margin-left: 10px;
    }
  }
  .addMsg {
    width: 561px;
    height: 228px;
    border: 1px solid rgba(220, 220, 220, 1);
    position: relative;
    padding: 25px 36px;
    position: relative;
    .cs-detail {
      width: 140px;
      height: 152px;
      background: rgba(252, 252, 252, 1);
      border: 1px solid rgba(214, 214, 214, 1);
      border-radius: 0px 0px 8px 8px;
      position: absolute;
      right: 37px;
      top: -11px;
      border-top: 2px solid #ca4300;
      .cs-label {
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        color: #b5b5b5;
        margin-bottom: 9px;
        height: 22px;
        line-height: 22px;
        background: #f5f5f5;
      }
      .cs-info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-bottom: 8px;
        img {
          width: 45px;
          height: 45px;
          border-radius: 50%;
        }
        .cs-name {
          text-align: center;
          font-size: 12px;
          font-weight: bold;
          color: #ca4300;
          margin: 10px 0;
          word-break: break-all;
        }
        .cs-name-en {
          text-align: center;
          font-size: 12px;
          font-weight: bold;
          color: #333333;
          word-break: break-all;
        }
      }
      .cs_line {
        width: 110px;
        height: 1px;
        border-top: 1px solid #d6d6d6;
        margin: 0 auto;
      }
      .cs-intr {
        padding-top: 14px;
        & > div {
          text-align: center;
          font-size: 12px;
          font-weight: 400;
          color: rgba(135, 135, 135, 1);
          margin-bottom: 5px;
        }
      }
    }
    .urge-btn {
      position: absolute;
      bottom: 25px;
      right: 36px;
    }
  }
}
.demand-content {
  background: #fff;
  margin-top: 27px;
  padding: 4px 32px 47px 32px;
  position: relative;
  .close-quote-btn {
    position: absolute;
    right: 32px;
    top: 26.5px;
    color: #878787;
    font-size: 14px;
    cursor: pointer;
    &:hover {
      color: #ca4300;
    }
  }
}
.demand-detail {
  margin-top: 32px;
  border: 1px solid rgba(210, 210, 210, 1);
  padding: 43px 31px;
  padding-bottom: 0;
  position: relative;
  .demand-row {
    display: flex;
    margin-bottom: 32px;
    &:last-child {
      margin: 0;
    }
    .demand-row-label {
      width: 169px;
      margin-right: 10px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      white-space: nowrap; /* 规定文本是否折行 */
      overflow: hidden; /* 规定超出内容宽度的元素隐藏 */
      text-overflow: ellipsis;
    }
    .demand-row-content {
      flex: 1;
      font-size: 14px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      white-space: nowrap; /* 规定文本是否折行 */
      overflow: hidden; /* 规定超出内容宽度的元素隐藏 */
      text-overflow: ellipsis;
      &.file {
        overflow: visible;
        white-space: pre-wrap;
      }
      &.user-info > span {
        margin-right: 40px;
      }
      .file-content {
        display: inline-block;
        margin-right: 20px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(33, 82, 205, 1);
        cursor: pointer;
        text-decoration: underline;
      }
      a {
        text-decoration: underline;
      }
    }
  }
}
.banner-content {
  /*height: 36px;*/
  width: 100%;
  &.fixed {
    position: fixed;
    bottom: 0;
    z-index: 999;
    .erweima {
      bottom: 0;
      z-index: 999;
    }
  }
  .wrap-lg {
    position: relative;
  }
  .erweima {
    bottom: -57px;
    z-index: 999;
  }
}
.erweima {
  position: absolute;
  right: 0;
  bottom: 0;
  .kf5-btn {
    width: 163px;
    height: 35px;
    padding: 0;
    background: #ca4300;
    border-radius: 5px 5px 0px 0px;
    line-height: 35px;
    margin-right: 4px;
    border: none;
    img {
      vertical-align: middle;
      margin-right: 10px;
    }
  }
  .wechart-btn {
    display: inline-block;
    width: 44px;
    background: rgba(65, 158, 50, 1);
    border-radius: 5px 5px 0px 0px;
    padding: 5.5px 0;
    text-align: center;
    cursor: pointer;
    img {
      vertical-align: middle;
    }
  }
  .wechat-div {
    position: absolute;
    width: 133px;
    height: 172px;
    background: url('../../assets/images/wechat-div.png');
    bottom: 35px;
    right: 0px;
    padding: 12px 10px 19px 10px;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    img {
      width: 108px;
      height: 108px;
    }
    .wechart-title {
      font-weight: bold;
      text-align: center;
    }
    .wechart-tips {
      text-align: center;
    }
  }
}
.project-content {
  margin-left: -31px;
  margin-right: -31px;
  padding-bottom: 38px;
}
.company-content {
  font-size: 30px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 45px;
  margin-bottom: 53px;
  padding-right: 113px;
  position: relative;
  width: 990px;

  & > img {
    position: absolute;
    right: -100px;
    top: 0;
  }
  .categoryPath {
    position: relative;
    &:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 1px;
      background: #7d7d7d;
      left: 0;
      bottom: -1px;
    }
  }
}
.order-basic {
  display: flex;
  width: 850px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(135, 135, 135, 1);
  line-height: 14px;
  padding-bottom: 20px;
  border-bottom: 1px solid #d8d8d8;
  margin-bottom: 42px;
  .basic-item:not(:last-child) {
    margin-right: 20px;
  }
  .basic-item-icon {
    display: inline-block;
    width: 2px;
    height: 14px;
    border: 2px solid #ca4300;
    margin-right: 10px;
    position: relative;
    top: 2px;
  }
  .basic-value {
    color: #333;
  }
}
.order-msg {
  width: 850px;
  min-height: 189px;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  margin-bottom: 20px;
  .order-user-msg {
    font-weight: bold;
  }
  .order-file-list {
    margin-top: 20px;
    display: flex;
    .order-file-item {
      display: flex;
      width: 144px;
      margin-right: 18px;
      cursor: pointer;
      &:hover {
        color: #ca4300;
      }
      img {
        width: 50px;
        height: 50px;
        margin-right: 10px;
      }
      .file-img {
        width: 50px;
        height: 50px;
        border: 1px solid #d2d2d2;
        padding: 10px 6px;
        margin-right: 10px;
        img {
          width: 36px;
          height: 28px;
          margin: 0;
        }
      }
      .file-name {
        flex: 1;
        max-height: 50px;
        font-size: 12px;
        line-height: 18px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-decoration: underline;
        color: blue;
      }
    }
  }
}
.specialNote {
  margin-bottom: 20px;
  color: #878787;
  font-size: 12px;
}
.cs-content {
  width: 220px;
  height: 265px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(220, 220, 220, 1);
  border-top: 2px solid #ca4300;
  box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.18);
  position: absolute;
  top: 46px;
  right: -12px;
  .cs-top {
    width: 218px;
    height: 24px;
    line-height: 24px;
    background: #f5f5f5;
    margin-bottom: 17px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #878787;
    opacity: 0.8;
    text-align: center;
  }
  .cs-info {
    padding: 0 26px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    img {
      width: 82px;
      height: 82px;
      border-radius: 50%;
    }
    .cs-name {
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      color: #ca4300;
      margin-bottom: 10px;
      word-break: break-all;
    }
    .cs-name-en {
      text-align: center;
      font-size: 12px;
      font-weight: bold;
      color: #333333;
      word-break: break-all;
    }
  }
  .cs-intr-label {
    width: 220px;
    height: 25px;
    background: rgba(250, 250, 250, 1);
    padding: 0 30px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 25px;
    margin-bottom: 10px;
    img {
      width: 8px;
      margin-right: 10px;
      position: relative;
      top: -2px;
    }
  }
  .cs-job {
    height: 21px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(135, 135, 135, 1);
    line-height: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 15px;
    .cs-job-icon {
      width: 5px;
      height: 5px;
      background: rgba(125, 125, 125, 1);
      opacity: 0.34;
      border-radius: 50%;
      margin: 0 11px;
    }
  }
  .cs-btn-content {
    text-align: center;
    margin-top: 10px;
    img {
      width: 100px;
      height: 100px;
      border: 1px solid #bbbbbb;
    }
  }
  .el-button.cs-btn {
    width: 119px;
    height: 32px;
    border-radius: 3px;
    background: #ffffff;
    border-color: #ca4300;
    color: #ca4300;
    padding: 0;
    margin-top: 16px;
  }
}
.quote-tip {
  margin-left: -31px;
  margin-right: -31px;
  background: #f5f5f5;
  width: 1160px;
  min-height: 63px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  display: flex;
  padding: 23px 0;

  .quote-tip-label {
    font-weight: bold;
    flex-shrink: 0;
    color: #ca4300;
    display: flex;

    img {
      margin-left: 39px;
      margin-right: 15px;
      width: 20px;
      height: 22px;
      margin-top: -4px;
    }
  }
  .quote-tip-content {
    font-size: 14px;
    color: #333333;
    width: 914px;
  }
  .kf5-btn-tips {
    color: #ca4300;
    /*padding: 0 20px 0 30px;*/
  }
}
.btns-content {
  height: 105px;
  border-bottom: 1px solid #d2d2d2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .el-button.is-plain {
    width: 142px;
    height: 32px;
    border-radius: 3px;
    background: #ffffff;
    border-color: #ca4300;
    color: #ca4300;
    padding: 0;
  }
  .kf5-btn-tips {
    font-size: 15px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }
  .el-button.kf5-btn {
    width: 142px;
    height: 35px;
    border-radius: 5px;
    padding: 0;
    img {
      margin-right: 5px;
      vertical-align: middle;
    }
  }
}
.more-content {
  padding: 20px 0;
  /*border-bottom: 1px solid #D2D2D2;*/
  .more-title {
    font-size: 18px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    margin-bottom: 27px;
  }
  .more-item {
    display: flex;
    &.other-item {
      padding: 5px 0 5px 0;
      line-height: 14px;
      .more-label {
        padding-left: 6px;
      }
    }
    .businessLine-btn {
      padding: 0;
    }
    &:not(:last-child) {
      margin-bottom: 15px;
    }
    .more-label {
      width: 115px;
      font-size: 14px;
      color: #333333;
      line-height: 14px;
      .label-span {
        display: inline-block;
        background: #fff4ee;
        border-radius: 3px;
        padding: 5px 6px;
        color: #ca4300;
      }
    }
    .more-value {
      font-size: 14px;
      color: #333333;
      flex: 1;
    }
    .more-item-determine {
      display: flex;
      align-items: center;
    }
  }
  .day-tips {
    font-size: 14px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }
}
.price-content {
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  background: #f8f8f8;
  .btns {
    position: relative;
    display: flex;
    .confirm-order-btn {
      img {
        vertical-align: middle;
      }
    }
  }
  .submit-demand {
    padding: 0;
    border: none;
    color: #878787;
    text-decoration: underline;
  }
  .price-detail {
    width: 100%;
  }
  .price-label {
    font-size: 14px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 30px;
  }
  .price-item {
    display: flex;
    margin-bottom: 15px;
    .price-item-label {
      font-size: 14px;
      color: #333333;
      line-height: 24px;
      width: 123px;
      text-align: right;
      &.total {
        font-weight: bold;
      }
      &.tips {
        font-size: 16px;
        font-weight: bold;
        color: #ca4300;
        line-height: 30px;
        width: 100%;
        text-align: center;
      }
    }
    .price-item-content {
      flex: 1;
      margin-left: 10px;
      padding-right: 26px;
      text-align: right;
      font-size: 14px;
      color: #ca4300;
      line-height: 24px;
      &.total {
        font-weight: bold;
      }
    }
  }
}
.price-btn {
  display: flex;
  flex-direction: row;
  margin-top: 30px;
}
.print-page {
  text-align: center;
  font-size: 14px;
  color: rgba(135, 135, 135, 1);
  line-height: 28px;
  .btn {
    display: inline-block;
    cursor: pointer;
    width: 114px;
    height: 35px;
    border: 1px solid #ec6519;
    border-radius: 5px;
    color: #ec6519;
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 33px;
  }
  img {
    vertical-align: middle;
    margin-right: 5px;
  }
}
.submit-demand-btn {
  width: 150px;
  height: 50px;
  padding: 0;
  display: block;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #8d8d8d;
  border: 1px solid #c8c8c8;
  background: #ffffff;
  border-radius: 0px;
  margin-left: 23px;
}
.qry-order-btn-pri {
  width: 150px;
  height: 50px;
  padding: 0;
  display: block;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  background: #ca4300;
  border-radius: 0px;
}
.btns {
  text-align: center;
  .qry-order-btn,
  .repeat-btn {
    width: 210px;
    height: 50px;
    padding: 0;
    border-radius: 0;
    font-size: 16px;
    background: #ca4300;
    margin-left: 23px;
    img {
      vertical-align: bottom;
      width: 22px;
    }
  }
  .repeat-btn {
    border: 1px solid #ca4300;
    color: #ca4300;
  }
}
.give-away-icon {
  display: inline-block;
  width: 23px;
  height: 23px;
  background: #ca4300;
  border-radius: 50%;
  font-size: 14px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 23px;
  margin-left: 10px;
  text-align: center;
}
.search-plan {
  .search-plan-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 15px;

    p {
      font-weight: bold;
      width: 90px;
    }
    em {
      padding-left: 10px;
    }
  }
}
</style>
<style lang="scss">
.share-btn > span {
  display: flex;
  flex-direction: column;
  img {
    width: 22px;
    height: 22px;
    margin-bottom: 4px;
    align-items: center;
  }
}
.more-content {
  .el-radio {
    line-height: 24px;
  }
  .businessLine-btn {
    padding: 0;
    border: none;
    line-height: 24px;
    font-size: 14px;
    text-decoration: underline;
    color: rgba(135, 135, 135, 0.87);
  }
}
.el-tooltip__popper.is-light.prev-img {
  border: none;
  padding: 5px;
  border-radius: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 30%);
}
.log-content {
  .el-timeline-item {
    padding-bottom: 15px;
  }
  .el-timeline-item__content {
    font-size: 14px;
    font-weight: 400;
    color: #878787;
  }
  .el-timeline-item:first-child .el-timeline-item__content {
    color: #333;
    /*color: #ca4300;*/
  }
}
.add-msg-input,
.add-msg-input .el-textarea__inner {
  padding: 0px;
  width: 300px;
  height: 121px;
  margin-top: 0px;
  margin-bottom: 0px;
  border: none;
  .el-input__count {
    left: 0;
    bottom: -13px;
  }
}
.demand-content {
  .el-menu.el-menu--horizontal {
    border-bottom: 3px solid #dbdbdb;
  }
  .el-menu--horizontal > .el-menu-item,
  .el-menu--horizontal > .el-menu-item:hover {
    position: relative;
    bottom: -3px;
    border-bottom: 3px solid #dbdbdb !important;
    font-size: 18px;
  }
  .el-menu--horizontal > .el-menu-item.is-active,
  .el-menu--horizontal > .el-menu-item.is-active:hover {
    border-bottom: 3px solid #ca4300 !important;
    color: #ca4300;
    font-weight: bold;
  }
}
.project-table {
  .test-item-btn {
    color: #b9b9b9;
    cursor: pointer;
    i {
      display: inline-block;
      width: 16px;
      height: 16px;
      text-align: center;
      border: 1px solid #b9b9b9;
      line-height: 14px;
      margin-right: 5px;
    }
    &.add-item {
      color: #ca4300;
      i {
        border: 1px solid #ca4300;
      }
    }
  }
  th {
    padding: 13.5px 0;
    background: #f6f6f6;
    &:not(:nth-child(9)) .cell {
      border-right: 1px solid #d2d2d2;
    }
  }
  th > .cell {
    font-size: 14px;
    font-weight: 400;
    color: rgba(135, 135, 135, 1);
    line-height: 18px;
  }
  th.is-leaf,
  td {
    border-bottom: none;
  }
  &::before {
    display: none;
  }
  td {
    padding: 13.5px 0;
  }
  td > .cell {
    font-size: 14px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
  }
  .index-cell {
    padding-left: 22px;
  }
  td.day-cell {
    padding-right: 56px;
  }
  .project-cell .cell {
    font-weight: bold;
  }
  // td.num-cell {
  //   /*padding-left: 56px;*/
  //   .cell {
  //     /*text-align: right;*/
  //   }
  // }
  td.yangpin-cell .cell {
    padding: 0;
    display: flex;
  }
  .yangpin-tab {
    height: 22px;
    background: #f6f6f6;
    border: 1px solid #dcdcdc;
    border-radius: 3px;
    font-size: 14px;
    font-family: Arial;
    font-weight: 400;
    color: #878787;
    line-height: 20px;
    max-width: 202px;
    padding: 0 3px;
    white-space: nowrap; /* 规定文本是否折行 */
    overflow: hidden; /* 规定超出内容宽度的元素隐藏 */
    text-overflow: ellipsis;
    &:not(:first-child) {
      margin-left: 5px;
    }
  }
}
.el-dialog__header {
  border-bottom: 1px solid #ddd;
}
.title_style {
  overflow-wrap: break-word;
  word-wrap: break-word;

  -ms-word-break: break-all;
  /* 这个的使用在web-kit中有些危险，他可能会阶段所有东西 */
  word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;

  /* 如果浏览器支持的话增加一个连接符(Blink不支持) */
  // -ms-hyphens: auto;
  // -moz-hyphens: auto;
  // -webkit-hyphens: auto;
}
</style>
